import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareLayoutIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 64 64' fill='none' {...props}>
    <path
      d='M52.002 47.386V31.444H24v15.942h-4V31.444H8V15.422h4v11.91h28v-11.91h4v11.91h12v20.054h-4z'
      fill='currentColor'
    />
    <path
      d='M56 47.385h-4V31.444H24v15.94h-4v-15.94H8V15.42h4v11.91h28.002V15.42h4v11.91H56v20.054z'
      fill='currentColor'
    />
    <path
      d='M12.001 53.46a9.981 9.981 0 011.82-5.472 9.999 9.999 0 0110.298-4.01 10.004 10.004 0 015.047 2.796 9.985 9.985 0 012.045 10.85 9.991 9.991 0 01-3.684 4.438 10.009 10.009 0 01-5.525 1.666 10.15 10.15 0 01-7.129-3.067 10.126 10.126 0 01-2.872-7.202zm32.001-.16a9.98 9.98 0 011.801-5.483 10 10 0 0110.294-4.044 10.003 10.003 0 015.057 2.787 9.985 9.985 0 012.063 10.855 9.992 9.992 0 01-3.684 4.445 10.01 10.01 0 01-5.53 1.668 10.13 10.13 0 01-7.12-3.046 10.106 10.106 0 01-2.88-7.182zm-12-43.591a9.981 9.981 0 011.82-5.471A9.999 9.999 0 0144.119.228a10.003 10.003 0 015.047 2.796 9.985 9.985 0 012.046 10.849 9.991 9.991 0 01-3.684 4.438 10.009 10.009 0 01-5.526 1.666 10.15 10.15 0 01-7.128-3.066 10.126 10.126 0 01-2.872-7.202zM0 9.709a9.981 9.981 0 011.82-5.471A9.999 9.999 0 0112.118.228a10.004 10.004 0 015.048 2.796 9.984 9.984 0 012.044 10.849 9.99 9.99 0 01-3.683 4.438 10.01 10.01 0 01-5.526 1.666 10.152 10.152 0 01-7.13-3.065A10.128 10.128 0 01.002 9.71z'
      fill='currentColor'
    />
  </SvgWrapper>
);
export const LayoutIcon = memo(BareLayoutIcon);
